/**
 * 商品情報更新リクエスト用VO
 *
 * @export RequestGetGoodsInfoListModel
 * @class RequestGetGoodsInfoListModel
 */
export class RequestGetGoodsInfoListModel {
  /**
   *  コマID
   */
  public komaID = Number(0);

  /**
   *  注文商品区分
   */
  public orderGoodsFlg = String('');
}
